import moment from 'moment';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fetchContentData } from 'services/QuoteLinkService';
import { DEFAULT_SECONDARY_COLOUR } from 'shared/constants/styleConstants';
import LastComponent from './common/lastComponent';

export default function AccommodationSection({ componentProps }) {
  const { theme } = useSelector((state) => state.ui);
  const { componentFullName, componentName, componentData, isLastComponent } =
    componentProps;
  const [images, setImages] = useState([]);
  const component = componentData[componentFullName];

  useEffect(() => {
    const getContentData = async (queryString) => {
      const { data } = await fetchContentData(queryString);
      setImages(data);
    };

    if (component.name && component.resort) {
      getContentData(
        `type==accommodation$ANDresort==${component.resort}&ANDdestination==${component.name}`,
      );
    }
  }, [component.name, component.resort]);

  return (
    <div className="flex mt-[30px] xs:mt-[40px] items-start relative">
      <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="relative z-10 hidden xs:inline"
      >
        <circle
          cx="25"
          cy="25"
          r="25"
          fill={theme.brandColour || DEFAULT_SECONDARY_COLOUR}
        />
        <path
          d="M22 25C23.66 25 25 23.66 25 22C25 20.34 23.66 19 22 19C20.34 19 19 20.34 19 22C19 23.66 20.34 25 22 25ZM34 19H26V26H18V17H16V32H18V29H36V32H38V23C38 20.79 36.21 19 34 19Z"
          fill="white"
        />
      </svg>

      <div className="xs:ml-[16px] mt-2">
        <div className="text-[22px] leading-[29.05px] font-medium flex xs:block items-center">
          <svg
            width="38"
            height="38"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="relative z-10 inline xs:hidden"
          >
            <circle
              cx="25"
              cy="25"
              r="25"
              fill={theme.primaryColour || DEFAULT_SECONDARY_COLOUR}
            />
            <path
              d="M22 25C23.66 25 25 23.66 25 22C25 20.34 23.66 19 22 19C20.34 19 19 20.34 19 22C19 23.66 20.34 25 22 25ZM34 19H26V26H18V17H16V32H18V29H36V32H38V23C38 20.79 36.21 19 34 19Z"
              fill="white"
            />
          </svg>
          <span className="ml-2.5 xs:ml-0">{componentName}</span>
        </div>
        <div className="max-w-10/12 text-[16px] leading-[31.2px] tracking-[0.25px] font-normal mt-[22px]">
          <strong>{component.name}</strong>
          {component.resort ? `, ${component.resort}` : ''}
          {component.starRating ? `, ${component.starRating} star` : ''}
          <br />
          Check in:{' '}
          {moment(Number(component.checkInDate)).format('DD MMMM yyyy')}, Check
          out: {moment(Number(component.checkOutDate)).format('DD MMMM yyyy')}
          <br />
          {component.roomType && <div>Room type: {component.roomType}</div>}
          {component.boardBasis && (
            <div>Board basis: {component.boardBasis}</div>
          )}
          <div className="flex flex-wrap mt-8 xs:mt-4">
            {images.map((image) => (
              <img
                src={`/api/v1.10/content/${image.img_content_name}`}
                className="w-full xs:w-5/12 mr-3 mb-3"
                alt="img_content_name"
              />
            ))}
          </div>
        </div>
      </div>

      {isLastComponent && <LastComponent />}
    </div>
  );
}
